import { saveAs } from "file-saver";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useEffect, useState } from "react";
import DatePicker from 'react-datepicker';
import { MdEmail } from "react-icons/md";
import Select from 'react-select'; // 🔹 You forgot this
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';


import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";
// import './EmailBooking.css'; // Optional: for your custom styles
import { FaFileExcel, FaFilePdf, FaPaperPlane } from "react-icons/fa";

function EmailBooking() {
  const [getCustomer, setGetCustomer] = useState([]);
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const [formData, setFormData] = useState({
    fromdt: firstDayOfMonth,
    todt: today,
    CustomerName: ""
  });

  useEffect(() => {
    if (getCustomer.length === 0) return;

    const login = JSON.parse(localStorage.getItem("Login"));

    if (login?.UserType === "Admin") {
      setFormData(prev => ({
        ...prev,
        CustomerName: "ALL CLIENT DATA",
      }));
    } else {
      const customer = getCustomer.find(
        c => c.Customer_Code === login?.Customer_Code
      );
      if (customer) {
        setFormData(prev => ({
          ...prev,
          CustomerName: customer.Customer_Name,
        }));
      }


    }
  }, [getCustomer]);


  const allOptions =
    JSON.parse(localStorage.getItem("Login"))?.UserType === "Admin"
      ?
      [
        { label: "ALL CLIENT DATA", value: "ALL CLIENT DATA" },
        ...getCustomer.map((cust) => ({
          label: cust.Customer_Name,
          value: cust.Customer_Code,
        })),
      ]
      :
      Array.isArray(getCustomer) && getCustomer.length > 0
        ? getCustomer
          .map(cust => ({
            label: cust.Customer_Name,
            value: cust.Customer_Code,
          }))
        : []
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [EmailData, setEmailData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedDockets, setSelectedDockets] = useState([]);

  const formatDate = (date) => {
    if (!date) return "";

    const d = new Date(date); // convert string → Date object

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${day}/${month}/${year}`;
  };

  // Example
  console.log(formatDate("2020-10-01")); // 10/10/2020

  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const response = await getApi(`/Master/getCustomerdata?Branch_Code=${JSON.parse(localStorage.getItem('Login'))?.Branch_Code}&Customer_Code=${JSON.parse(localStorage.getItem('Login'))?.Customer_Code}`);
        if (response?.status === 1 && Array.isArray(response.Data)) {
          setGetCustomer(response.Data);
        }
      } catch (err) {
        console.error('Error loading customer data:', err);
      }
    };
    fetchCustomerData();
  }, []);



  const handleSearchChange = (selectedOption) => {
    setFormData({ ...formData, CustomerName: selectedOption ? selectedOption.value : "" });
  };

  const handlesave = async (e) => {
    e.preventDefault();
    const fromdt = formatDate(formData.fromdt);
    const todt = formatDate(formData.todt);
    const { CustomerName } = formData;

    if (!fromdt || !todt) {
      Swal.fire('Error', 'Both From Date and To Date are required.', 'error');
      return;
    }

    try {
      const response = await getApi(`/Booking/AutoMailsend?Branch_Code=${JSON.parse(localStorage.getItem('Login'))?.Branch_Code}&CustomerName=${encodeURIComponent(allOptions.find(c => c.value === CustomerName)?.label)}&fromdt=${fromdt}&todt=${todt}`);
      if (response.status === 1) {
        setEmailData(response.Data);
        setSelectedDockets([]);
        Swal.fire('Saved!', response.message || 'Data has been fetched.', 'success');
      } else {
        setEmailData([]);
        Swal.fire('No Data', response.message || 'No records found.', 'info');
      }
    } catch (error) {
      console.error("API Error:", error);
      setEmailData([]);
      Swal.fire('Error', 'No Booking Available..', 'error');
    }
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = EmailData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(EmailData.length / rowsPerPage);

  const handleCheckboxChange = (docketNo) => {
    setSelectedDockets((prev) =>
      prev.includes(docketNo) ? prev.filter((item) => item !== docketNo) : [...prev, docketNo]
    );
  };

   const handleRowsPerPageChange = (event) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };
    const handlePreviousPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

  useEffect(() => {
    console.log(formData);
  }, [formData])
  const exportSelectedToPDF = () => {
    if (selectedDockets.length === 0) {
      Swal.fire("Error", "Please select at least one docket", "error");
      return;
    }

    const selectedData = EmailData.filter((row) =>
      selectedDockets.includes(row.DocketNo)
    );

    const doc = new jsPDF();

    const headers = [
      [
        "DocketNo",
        "Book Date",
        "Customer",
        "Consignee",
        "Origin",
        "Destination",
        "Mode",
        "Qty",
        "Weight",
      ],
    ];

    const body = selectedData.map((item) => [
      item.DocketNo,
      item.BookDate ? new Date(item.BookDate).toLocaleDateString("en-GB") : "",
      item.Customer_Name,
      item.Consignee_Name,
      item.Origin_Name,
      item.Destination_Name,
      item.Mode_Name,
      item.Qty,
      item.ActualWt,
    ]);

    doc.text("Selected Booking Data", 14, 10);
    doc.autoTable({
      head: headers,
      body,
      startY: 20,
    });

    doc.save("SelectedDockets.pdf");
  };

  const formatTimeAMPM = (timeStr) => {
    if (!timeStr) return "";
    const [hours, minutes] = timeStr.split(":").map(Number);
    const ampm = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12;
    return `${hours12}:${minutes.toString().padStart(2, "0")} ${ampm}`;
  };



  const exportSelectedToExcel = () => {
    if (selectedDockets.length === 0) {
      Swal.fire("Error", "Please select at least one docket to export", "error");
      return;
    }
    // Filter only selected rows
    const selectedData = EmailData.filter((row) =>
      selectedDockets.includes(row.DocketNo)
    );

    // Format the BookDate properly
    const formattedData = selectedData.map((row) => ({
      ...row,
      BookDate: row.BookDate ? new Date(row.BookDate).toLocaleDateString("en-GB") : "",
    }));

    // Create Excel workbook
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Data");

    // Write to file
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `SelectedDockets_${new Date().toISOString().slice(0, 10)}.xlsx`);

  };

  const sendMail = async () => {
    try {
      if (!formData || !getCustomer) {
        Swal.fire("Warning", "Required data not loaded. Please try again.", "warning");
        return;
      }

      if (!formData.CustomerName) {
        Swal.fire("Warning", "Please select a Customer to send mail.", "warning");
        return;
      }
      if (!selectedDockets?.length) {
        Swal.fire("Warning", "Please select at least one docket to export", "warning");
        return;
      }

      const selectedCustomer = getCustomer.find(
        cust => cust.Customer_Code === formData.CustomerName
      );
      console.log("Selected Customer:", selectedCustomer);

      if (selectedCustomer?.Email === false || !selectedCustomer?.Email_Id) {
        Swal.fire("Warning", "This customer has not provided an email. Check in master.", "warning");
        return;
      }

      // Filter only selected rows
      const selectedData = EmailData.filter((row) =>
        selectedDockets.includes(row.DocketNo)
      );

      // Format the BookDate properly
      const formattedData = selectedData.map((row) => ({
        ...row,
        BookDate: row.BookDate ? new Date(row.BookDate).toLocaleDateString("en-GB") : "",
      }));

      // Create Excel workbook
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Data");

      // Write to file
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const file = new Blob([excelBuffer], { type: "application/octet-stream" });
      console.log("Selected rows:", formattedData.length);
      const fileName = `Booking_${new Date().toISOString().slice(0, 10)}.xlsx`;
      const formDataToSend = new FormData();
      formDataToSend.append("file", file, fileName);
      formDataToSend.append("customerCode", formData?.CustomerName || "764");
      formDataToSend.append(
        "locationCode",
        JSON.parse(localStorage.getItem("Login"))?.BranchP_Code || "MUM"
      );
      formDataToSend.append("subject", "Docket Excel File");
      formDataToSend.append("message", "You can download excel file.");

      console.log("📦 Sending mail with data:", Object.fromEntries(formDataToSend.entries()));

      const response = await postApi("/Smart/AutoMailSend", formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response?.success) {
        Swal.fire("✅ Success", `Email sent successfully to ${response?.to}`, "success");
        setSelectedDockets([]);
      } else {
        Swal.fire("❌ Error", response?.error || "Email sending failed", "error");
      }
    } catch (error) {
      console.error("Email send failed:", error);
      Swal.fire("Error", "Failed to send email. Please check your network or server.", "error");
    }
  };



  const handleSelectAll = () => {
    setSelectedDockets(
      selectedDockets.length === currentRows.length ? [] : currentRows.map((item) => item.DocketNo)
    );
  };


  const handleDateChange = (date, field) => {
    setFormData({ ...formData, [field]: date });
  };

  return (


    <div className="body">
      <div className="container1">

        <form onSubmit={handlesave}>
          <div className="fields2" >
            {/* 🔍 react-select Searchable Dropdown */}
            <div className="input-field1">

              <label >Customer_Name</label>

              < Select
                className="blue-selectbooking"
                classNamePrefix="blue-selectbooking"
                options={allOptions}
                value={formData.CustomerName ? { label: allOptions.find(c => c.value === formData.CustomerName)?.label || "", value: formData.CustomerName } : null}
                onChange={handleSearchChange}
                placeholder="Search Customer..."
                isClearable
                noOptionsMessage={() => "Customer not found"}
                menuPortalTarget={document.body}
                styles={{
                  control: (base) => ({ ...base, minHeight: "32px", fontSize: "0.85rem" }),
                  menu: (base) => ({ ...base, zIndex: 9999 })
                }}
              />
            </div>

            <div className="input-field3">

              <label  >From Date</label>
              <DatePicker
                portalId="root-portal"
                selected={formData.fromdt}
                onChange={(date) => handleDateChange(date, "fromdt")}
                dateFormat="dd/MM/yyyy"
                className="form-control form-control-sm"
              />
            </div>

            <div className="input-field3">
              <label  >To Date</label>
              <DatePicker
                portalId="root-portal"
                selected={formData.todt}
                onChange={(date) => handleDateChange(date, "todt")}
                dateFormat="dd/MM/yyyy"
                className="form-control form-control-sm"
              />
            </div>


            
             
            <div style={{display:"flex",justifyContent:"end",flexWrap:"wrap",gap:"10px",width:"100%",padding:"10px"}}>
            
                <button
                  type="submit"
                  style={{display:"flex",justifyContent:"center",gap:"5px",
                  alignItems:"center",padding:"7px 12px",fontSize:"10px",borderRadius:"5px",border:"none"}}
                  className="ok-btn"
                >
                  <FaPaperPlane size={15} />
                  <span>Submit</span>
                </button>
            
                <button
               style={{display:"flex",justifyContent:"center",gap:"5px",
                  alignItems:"center",padding:"7px 12px",fontSize:"10px",borderRadius:"5px",border:"none"}}
                  className="ok-btn"
                  type="button"
                 onClick={sendMail}
                >
                  <MdEmail size={15} />
                  <span>Mail</span>
                </button>
            
                <button
                 style={{display:"flex",justifyContent:"center",gap:"5px",
                  alignItems:"center",padding:"7px 12px",fontSize:"10px",borderRadius:"5px",border:"none"}}
                  className="ok-btn"
                  type="button"
                  
                  onClick={exportSelectedToExcel}
                >
                  <FaFileExcel size={15} />
                  <span>Excel</span>
                </button>
            
                <button
                  type="button"
                  style={{display:"flex",justifyContent:"center",gap:"5px",
                  alignItems:"center",padding:"7px 12px",fontSize:"10px",borderRadius:"5px",border:"none"}}
                  className="ok-btn"
                  onClick={exportSelectedToPDF}
                >
                  <FaFilePdf size={15} />
                  <span>PDF</span>
                </button>
            
              </div>


          </div>
        </form>

        {/* 📋 Table */}
        <div className='table-container'>
          <table className='table table-bordered table-sm' style={{ whiteSpace: "nowrap" }}>

            <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
              <tr>
                <th className="w-60">
                  <input type="checkbox" onChange={handleSelectAll} checked={currentRows.length > 0 && selectedDockets.length === currentRows.length} />
                  </th>
                <th className="w-60">Sr.No</th>
                <th>DocketNo</th>
                <th>Book_Date</th>
                <th>Customer</th>
                <th>Consignee</th>
                <th>Origin</th>
                <th>Destination</th>
                <th>Mode</th>
                <th>Vendor</th>
                <th>Vendor_Docket</th>
                <th>Flag</th>
                <th>Qty</th>
                <th>Weight</th>
                <th>Status</th>
                <th>Delivery_Date</th>
                <th>Delivery_Time</th>
                <th>Remark</th>
              </tr>
            </thead>
            <tbody style={{ fontWeight: "normal", fontSize: "8px" }}>
              {currentRows.length === 0 ? (
                <tr>
                  <td colSpan="18" className="text-center text-danger">No Data Found</td>
                </tr>
              ) : (
                currentRows.map((item, index) => (
                  <tr key={index}>
                    <td className="w-60"><input type="checkbox" checked={selectedDockets.includes(item.DocketNo)} onChange={() => handleCheckboxChange(item.DocketNo)} /></td>
                    <td className="w-60">{indexOfFirstRow + index + 1}</td>
                    <td>{item.DocketNo}</td>
                    <td>{item.BookDate ? new Date(item.BookDate).toLocaleDateString('en-GB') : ''}</td>
                    <td>{item.Customer_Name}</td>
                    <td>{item.Consignee_Name}</td>
                    <td>{item.Origin_Name}</td>
                    <td>{item.Destination_Name}</td>
                    <td>{item.Mode_Name}</td>
                    <td>{item.Vendor_Name}</td>
                    <td>{item.VendorAwbno}</td>
                    <td>{item.T_Flag}</td>
                    <td>{item.Qty}</td>
                    <td>{item.ActualWt}</td>
                    <td>{item.Status}</td>
                    <td>{formatDate(item.DelvDT)}</td>
                    <td>{formatTimeAMPM(item.DelvTime)}</td>
                    <td>{item.Remark}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="row" style={{ whiteSpace: "nowrap" }}>
                        <div className="pagination col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0">
                            <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                                {'<'}
                            </button>
                            <span style={{ color: "#333", padding: "5px" }}>
                                Page {currentPage} of {totalPages}
                            </span>
                            <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                                {'>'}
                            </button>
                        </div>

                        <div className="rows-per-page col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center">
                            <span htmlFor="rowsPerPage" className="me-2">Rows per page: </span>
                            <select
                                id="rowsPerPage"
                                value={rowsPerPage}
                                onChange={(e) => {
                                    setRowsPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
  
                                style={{ height: "40px", width: "50px" ,border:"1.5px solid #002357"}}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                            </select>
                        </div>
                    </div>
      </div>
    </div>
  );
}

export default EmailBooking;
